export function getSharedAuthEnabled() {
  const value = String(import.meta.env.VITE_SHARED_AUTH_ENABLED);

  return value === 'true';
}
